import { useEffect, useState } from "react";

import FormValidatorCtxBo from "../ctx-provider/FormValidatorCtxBo";
import useFormValidatorCtx from "../ctx-provider/useFormValidatorCtx";
import InputValidationStateBo from "./InputValidationStateBo";
import InputValidatorI from "./InputValidatorI";

let VALIDATOR_NUMBER = 0;
export const generateValidatorId = (key: string) => `${key}-${VALIDATOR_NUMBER++}`;

const useInputSubmitValidator = (inputValidatorId: string, inputValidator: InputValidatorI, validatorIndex = 0) => {
    const [valState, setValState] = useState(new InputValidationStateBo());
    const { fireFormValidatorCtxBo } = useFormValidatorCtx();

    const validatorId = `${inputValidatorId}_${validatorIndex}`;

    // Validierung wird ausgefuehrt    
    const validateValue = (inputValueType: InputValidatorI): boolean => {
        const result = inputValueType.validate();

        if (result === null || result === undefined) {
            throw Error('Validation result is null or undefined.');
        }

        setValState(result);

        if (result.error) {
            FormValidatorCtxBo.addError(validatorId);
        } else {
            FormValidatorCtxBo.removeError(validatorId)
        }

        fireFormValidatorCtxBo();
        return !result.error;
    };

    // ***************************
    // init and clean up
    // ***************************
    useEffect(() => {
        return (() => {
            // Wichtig! 
            // 1. Static Methoden, um eine Endlosschleife zu verhindern
            // 2. useEffect init mit leeren Parameter[]: 
            // Die CleanUp Funktion referenziert in diesem FAll IMMER das ERSTE Objekt und nicht das aktuellste!!!!!             

            // Die Fehlermeldung wird entfernt und die Komponenten werden darüber informiert
            FormValidatorCtxBo.removeError(validatorId);
            fireFormValidatorCtxBo();
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // ***************************
    // form submit validation 
    // ***************************
    // Die Function wird beim ersten Mal und bei jeder Aenderung vom validationTrigger ausgefuehrt.    
    useEffect(() => {
        if (FormValidatorCtxBo.runFormValidation) {
            validateValue(inputValidator);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [FormValidatorCtxBo.runFormValidationTrigger]);


    return {
        validationState: valState,
        /** Liefert true zurueck, wenn kein Fehler vorhanden ist */
        fireFieldValidation: validateValue,
    }
}

export default useInputSubmitValidator;